import { Theme } from '@mui/material'

import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles<{ isExternal?: boolean }>()(
  (theme: Theme, { isExternal }) => ({
    container: {
      padding: theme.spacing(4, 4, 0, 4),
      whiteSpace: 'nowrap',
    },
    resizeFontTextField: {
      width: 255,
      '& .MuiInputBase-input': {
        fontSize: '14px',
      },
      '& .MuiInputLabel-formControl': {
        fontSize: '14px',
      },
      '& .MuiFormHelperText-root.Mui-error': {
        fontSize: '11px',
      },
    },
    defaultValueWidth: {
      width: '220px',
    },
    selectField: {
      width: '211px',
      '& .MuiInputBase-input': {
        fontSize: '13px',
        color: theme.palette.black.main,
        textAlign: 'left',
      },
      '& .MuiInputLabel-root': {
        fontSize: '13px',
        color: theme.palette.primary.light,
        fontWeight: 600,
      },
      '& .MuiFormHelperText-root.Mui-error': {
        fontSize: '11px',
      },
      '& .MuiFormLabel-asterisk.MuiInputLabel-asterisk': {
        color: theme.palette.requiredAsterisk.main,
      },
    },
    menuRoot: {
      '&.MuiMenuItem-root': {
        fontSize: '13px',
        color: theme.palette.headerTitle.main,
      },
      '&.MuiListItem-gutters': {
        padding: theme.spacing(1.5),
      },
      '&.MuiListItem-root.Mui-selected': {
        backgroundColor: theme.palette.selectionBackgroundColor.main,
      },
      '&.MuiListItem-button:hover': {
        backgroundColor: theme.palette.selectionBackgroundColor.main,
      },
    },
    submitButton: {
      marginRight: theme.spacing(3),
    },
    actionIcon: {
      color: theme.palette.icon.main,
      height: '24px',
      width: '24px',
      cursor: 'pointer',
      marginRight: theme.spacing(3),
      '&.css-ptiqhd-MuiSvgIcon-root': {
        width: '20px',
        height: '20px',
      },
    },
    actionIconDisabled: {
      opacity: 0.3,
    },
    contractLink: {
      textDecoration: 'none',
      color: theme.palette.icon.main,
    },
    buttonContainer: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      width: '200px',
    },
    adminContainer: {
      padding: theme.spacing(4, 4, 0, 4),
      whiteSpace: 'nowrap',
    },
    labraResaleContainer: {
      padding: theme.spacing(3, 0, 0, 0),
    },
    createOfferBtn: {
      marginLeft: 'auto',
      paddingRight: theme.spacing(3),
    },
    createOfferLink: {
      textDecoration: 'none',
    },
    toolTipView: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    dropDownWidth: {
      width: theme.spacing(24),
    },
    createBtn: {
      width: theme.spacing(13),
    },
    dropdownAndProduct: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      gap: theme.spacing(2),
      marginBottom: theme.spacing(2.5),
    },
    gapBetween: {
      margin: 0,
    },
    marginTopSpace: {
      marginTop: theme.spacing(isExternal ? 2 : 5),
    },
    upperContainter: {
      display: 'flex',
      flexDirection: 'row',
    },
    externalApp: {
      display: 'inline',
    },
    justifySpaceBetween: {
      justifyContent: 'space-between',
    },
    justifyEnd: {
      justifyContent: 'flex-end',
    },
    filterComponent: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    filterSection: {
      display: 'flex',
      flexDirection: 'column',
      "[role='radiogroup'] div": {
        height: `${theme.spacing(5)} !important`,
      },
      "[role='radiogroup'] div label": {
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'row',
      },
    },
    filtersAppliedContainer: {
      display: 'flex',
      flexDirection: 'row-reverse',
      margin: theme.spacing(0, 2, 2.5, 0),
    },
    appliedFilter: {
      marginBottom: theme.spacing(-1),
    },
    filterCheckbox: {
      '& label': {
        height: `${theme.spacing(5)} !important`,
        alignItems: 'center !important',
      },
      '& .MuiCheckbox-root': {
        padding: `${theme.spacing(0, 1.5)} !important`,
        margin: 0,
      },
    },
  })
)
